<template>
    <!-- 一级导航 -->
    <div class="layous-home">
        <div class="layous-home-mai">
            <div class="layous-home1" data-aos="slide-down" data-aos-delay="0">
                <div class="layous-home1-L">
                    <div class="layous-home1-L1">
                        {{ timeDate | formatDate1(timeDate) }}
                    </div>
                    <div class="layous-home1-L2">
                        {{ timeDate | formatDate2(timeDate) }}
                    </div>
                </div>
                <div class="layous-home1-R">
                    <div class="layous-home1-R0">
                        {{ adminTxt }}
                    </div>
                    <div class="layous-home1-R1">
                        <el-popover placement="bottom" width="max-content">
                            <el-avatar slot="reference" :src="imgSrc"></el-avatar>
                            <div>
                                <el-avatar slot="reference" :src="imgSrc"></el-avatar>
                                <div style="line-height: 1.7;color: #909399;">
                                    <div>账号：{{ adminTxt }}</div>
                                    <div>
                                        公司：{{ showFirm.T_name ? showFirm.T_name : '还未选择公司哟~' }}
                                    </div>
                                </div>

                            </div>
                        </el-popover>
                    </div>
                    <div class="layous-home1-R1" @click="handleExit">
                        <span style="margin-left: 0px;font-size: 14px;text-decoration: underline;">退出登录</span>
                    </div>
                </div>
            </div>
            <div class="layous-home2">
                <div class="layous-home2-L" @click="_clickSystem('3D全景大屏', '/dataDisplay/DataView3d')"
                    data-aos="slide-right" data-aos-delay="0">
                    <div class="layous-home2-L-img"
                        style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;">
                        <i class="iconfont icon-chartmixed" style="font-size:3rem;color: #fff;"></i>
                    </div>
                    <div class="layous-home2-L-txt" style="font-weight: 100;margin-top: 10px;">
                        3D可视化管理平台
                    </div>
                </div>
                <div class="layous-home2-C" data-aos="slide-down" data-aos-delay="0">
                    <div class="layous-home2-C0 layous-home2-C1" @click="enterintellyouter">
                        <div class="layous-home2-L-img"
                            style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;">
                            <i class="iconfont icon-dingwei" style="font-size:2.5rem;color: #fff;"></i>
                        </div>
                        <div class="layous-home2-L-txt">
                            智配送管理平台
                        </div>
                    </div>
                    <div @click="_clickSystem('数据集成', '/MovingRing/MovingRingMonitoring')"
                        class="layous-home2-C0 layous-home2-C3">
                        <div class="layous-home2-L-img"
                            style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;">
                            <i class="iconfont icon-jicheng" style="font-size:2.5rem;color: #fff;"></i>
                        </div>
                        <div class="layous-home2-L-txt">
                            空调/除湿机管理平台
                        </div>
                    </div>
                    <div @click="_clickSystem('订单管理', '/Theorder/Theorder')" class="layous-home2-C0 layous-home2-C4">
                        <div class="layous-home2-L-img"
                            style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;">
                            <i class="iconfont icon-a-dingdan1" style="font-size:2.5rem;color: #fff;"></i>
                        </div>
                        <div class="layous-home2-L-txt">
                            订单管理平台
                        </div>
                    </div>
                    <div class="layous-home2-C0 layous-home2-C2">
                        <el-popover placement="top" style="width: 100%;height: 100%;" trigger="hover">
                            <el-table :data="tableData" border show-overflow-tooltip max-height="500"
                                empty-text="暂无第三方链接">
                                <el-table-column prop="systemName" label="系统名称">
                                </el-table-column>
                                <el-table-column prop="link" label="跳转链接" width="200">
                                </el-table-column>
                                <el-table-column label="操作" width="100">
                                    <template slot-scope="scope">
                                        <el-button size="small" @click="handleClick(scope.row.link)">跳转</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;flex: 1;height: 100%;"
                                slot="reference">
                                <div class="layous-home2-L-img"
                                    style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;">
                                    <i class="iconfont icon-disanfangfuwu" style="font-size:2.2rem;color: #fff;"></i>
                                </div>
                                <div class="layous-home2-L-txt">
                                    第三方平台
                                </div>
                            </div>
                        </el-popover>

                    </div>
                </div>
                <div class="layous-home2-R" data-aos="slide-left" data-aos-delay="0" @click="setnavigations">
                    <div class="layous-home2-L-img"
                        style="width: 50px;height: 50px;display: flex;align-items: center;justify-content: center;">
                        <i class="iconfont icon-cangkuwenshidu" style="font-size:3rem;color: #fff;"></i>
                    </div>
                    <div class="layous-home2-L-txt">
                        温湿度管理平台
                    </div>
                </div>
            </div>
        </div>
        <div class="layous-home-menu" data-aos="slide-up" data-aos-delay="0">
            <div class="layous-home-menu-item" v-for="item, index in restsMenu" @click="enterSystem(item)" :key="index">
                <i class="iconfont" :class="item.icon" style="font-size:2.2rem;color: #fff;"></i>
                <p style="margin-top: 10px;font-size: 12px;">{{ item.name }}</p>
            </div>
            <div class="layous-home-menu-item">
                <el-popover placement="right" style="width: 100%;height: 100%;" width="300" trigger="hover">
                    <div class="_popover">
                        <div class="_popover_item" v-for="item, j in moreMenu" @click="enterSystem(item)" :key="j">
                            <i class="iconfont" :class="item.icon" style="font-size:2.2rem;"></i>
                            <p style="font-size: 12px;">{{ item.name }}</p>
                        </div>
                    </div>
                    <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;flex: 1;height: 100%;"
                        slot="reference">
                        <i class="iconfont icon-gengduo" style="font-size:2.2rem;color: #fff;"></i>
                        <p style="margin-top: 10px;">更多平台</p>
                    </div>
                </el-popover>
            </div>
        </div>
        <el-dialog title="选择公司" custom-class="y-dialog" :visible.sync="dialogVisible" width="30%">
            <div style="border-top: 1px solid #DCDFE6;max-height: 60vh;overflow-y: auto;">
                <el-tree :data="tableTree" style=" background-color: transparent;" node-key="Id"
                    :props="{ children: 'Children', label: 'T_name' }" accordion :expand-on-click-node="true">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <div>{{ data.T_name }}</div>
                        <div>
                            <el-button type="text" @click="() => _onclickTree(data)">
                                进入
                            </el-button>
                        </div>
                    </span>
                </el-tree>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { companyGet } from "@/utils/CompanyGet"
import { workList } from "@/api/workbench.js"
import { CompanyTree, CompanyEntry } from '@/api/companyManagement/Company.js'
import { mapGetters } from "vuex"
import { restsMenu, moreMenu } from '@/views/layout/routerData.js'
import { request } from "qiniu-js/esm/utils"
export default {
    computed: mapGetters(["showFirm"]),
    data() {
        return {
            tableTree: [],
            dialogVisible: false,
            imgSrc: 'data:image/gif;base64,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',
            timeDate: new Date(),
            timer: null,
            adminTxt: '游客',
            showItem: [
                {
                    name: '数据集成',
                    store: true
                },
                {
                    name: '3D全景大屏',
                    store: true
                },
                {
                    name: '订单管理',
                    store: true
                }
            ],
            _goRouter: '',
            restsMenu: restsMenu,
            moreMenu: moreMenu,
            tableData: []
        }
    },
    mounted() {
        // 实时-时间-计时
        companyGet().then((res) => {
            this.tableData = res
        })
        var that = this
        this.adminTxt = this.$store.state.userInfo.username
        this.timer = setInterval(function () {
            that.timeDate = new Date()
        }, 1000)

    },
    methods: {
        handleClick(url) {
            window.open(url, '_blank');
        },
        enterSystem(item) {
            if (item.url) {
                const user = this.$store.state.userInfo.username
                let newUrl = ''
                if (user == item.flag) {
                    const { account, password } = item;
                    const data = { account, password };
                    const base64Data = btoa(encodeURIComponent(JSON.stringify(data)));
                    newUrl = `${item.url}?data=${encodeURIComponent(base64Data)}`;
                } else {
                    newUrl = item.url
                }
                window.open(newUrl, '_blank')
                return;
            } else {
                this.$notify({
                    title: '提示',
                    message: '暂时无法访问该系统~~~',
                    type: 'warning'
                });
            }
        },
        async _onclickTree(e) {
            let self = this
            var res = await this._getCompanyEntryApi(e)
            if (res.data.Code === 200) {
                this.$store.dispatch('SETNAV', [])
                this.$router.push(self._goRouter)
                this.$store.dispatch('SETPANY', {
                    plan: e.T_key,
                    T_name: e.T_name,
                    bl: true,
                    Id: e.Id,
                })
            }
        },
        _getCompanyEntryApi(e) {
            return new Promise(resolve => {
                CompanyEntry({ T_pid: e.Id }).then(res => {
                    resolve(res)
                })
            })
        },

        checkStrInArr(arr, str) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].meta.title === str) {
                    return true;
                }
                if (arr[i].children && arr[i].children.length > 0) {
                    if (this.checkStrInArr(arr[i].children, str)) {
                        return true;
                    }
                }
            }
            return false;
        },
        async _clickSystem(str, router) {
            const flag = this.checkStrInArr(this.$store.state.nav, str)
            if (!flag) {
                this.$confirm('哎呀，暂时没有访问查看权限哟，看看其他吧~', '无权限', {
                    confirmButtonText: '我知道了',
                    cancelButtonText: '取消',
                    type: 'error',
                    showCancelButton: false,
                    center: true
                }).then(() => { }).catch(() => { });
                return;
            }
            const { data: result } = await workList({})
            if (result.Data.T_pid == 0) {
                this._goRouter = router
                this._getCompanyTreeApi()
            } else {
                this.$router.push(router)
            }
        },
        async _getCompanyTreeApi() {//列表树
            const { data: result } = await CompanyTree({ page: 1, page_z: 9999 })
            this.tableTree = result.Data.Data || []
            this.dialogVisible = true
        },
        //退出登录
        handleExit(command) {
            this.$router.replace('/')
            this.$store.commit('setuserInfo', {
                username: '',
                password: '',
                token: ''
            })
        },
        async enterintellyouter() {
            const user = this.$store.state.userInfo.username
            let url = 'https://colddelivery.coldbaozhida.com/login'
            let newUrl = ''
            if (user == 'bzddemo') {
                const data = { account: 'bzddemo', password: 'bzd0819' };
                const base64Data = btoa(encodeURIComponent(JSON.stringify(data)));
                newUrl = `${url}?data=${encodeURIComponent(base64Data)}`;
            } else {
                newUrl = url
            }
            window.open(newUrl, '_blank')
            return;
            this.$store.dispatch('SETPANY', { T_name: this.$store.state.showFirm.T_name, bl: false, plan: this.$store.state.showFirm.plan })
            if (this.$store.state.showData.setId != 0) {
                this.$router.push({
                    path: '/intelligentsystem'
                })
            } else {
                this.$confirm('请先选择进入公司后在进入智慧平台', '提示', {
                    confirmButtonText: '去进入公司',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$router.push({
                        path: '/companyManagement/Company'
                    })
                }).catch(() => {

                });
            }
        },
        setnavigations() {
            this.$router.push({
                path: '/layout'
            })
        }
    },
    // 实时-时间
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    },
    filters: {
        fomeTis(value) {
            var hours = value.getHours().toString().padStart(2, '0')
            var state = ''
            if (hours >= 0 && hours <= 10) {
                state = `早上好`;
            } else if (hours > 10 && hours <= 14) {
                state = `中午好`;
            } else if (hours > 14 && hours <= 18) {
                state = `下午好`;
            } else if (hours > 18 && hours <= 24) {
                state = `晚上好`;
            }
            return state
        },
        formatDate1(value) {
            var hour = value.getHours().toString().padStart(2, '0')
            var min = value.getMinutes().toString().padStart(2, '0')
            // var sec = value.getSeconds().toString().padStart(2,'0')
            return hour + ":" + min
        },
        formatDate2(value) {
            // var year = value.getFullYear()//年
            var month = (value.getMonth() + 1).toString().padStart(2, '0') //月
            var day = value.getDate().toString().padStart(2, '0')
            // var sec = formatNum(value.getSeconds())
            return month + "月" + day + "日"
        }
    },
}
</script>

<style scoped lang="scss">
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

::v-deep .el-tree-node__content {
    display: flex;
    align-items: center;
    height: 40px;
    cursor: pointer;
}
</style>
<style lang="scss" scoped>
@import url('https://at.alicdn.com/t/c/font_4979833_y8q326li438.css');

._popover {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    grid-gap: 0 30px;

    &_item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px 0;

        &:hover {
            background: rgba(#ccc, .2);
            cursor: pointer;
            border-radius: 8px;
        }
    }
}

.y-dialog {
    border-radius: 15px;
    background: linear-gradient(180deg, rgba(217, 231, 251, 1), rgba(248, 251, 255, 1));
}

.y-dialog>.el-dialog__body {
    padding: 20px;
}

@media screen and (min-width: 1100px) {
    .layous-home {
        user-select: none;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;

        .layous-home-mai {
            min-width: 1000px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .layous-home1 {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .layous-home1-L {
                    display: flex;
                    align-items: flex-end;

                    .layous-home1-L1 {
                        font-size: 50px;
                    }

                    .layous-home1-L2 {
                        line-height: 45px;
                        margin-left: 30px;
                    }
                }

                .layous-home1-R {
                    display: flex;
                    align-items: center;

                    .layous-home1-R0 {
                        text-align: right;
                        width: 150px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                        margin-right: -10px;
                        font-size: 20px !important;
                    }

                    .layous-home1-R1 {
                        font-size: 20px;
                        margin-left: 20px;
                        cursor: pointer;
                    }
                }
            }

            .layous-home2 {
                margin-top: 30px;
                display: grid;
                grid-template-columns: 2fr 4fr 2fr;
                grid-gap: 10px;
                min-height: 400px;

                .layous-home2-L {
                    flex: 1;
                    background: linear-gradient(to top right, #f59342, #f7ae72);
                    ;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    transition: all .2s;
                    cursor: pointer;

                    .layous-home2-L-img {
                        margin-top: 10px;
                    }

                    .layous-home2-L-txt {
                        margin-top: 10px;
                        font-size: 14px;
                    }
                }

                .layous-home2-L:hover {
                    transform: scale(1.1);
                    z-index: 2;
                    border-radius: 10px;
                    box-shadow: 0 0 30px 10px rgba(0, 0, 0, 0.5);
                }

                .layous-home2-C {
                    flex: 4;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    grid-gap: 10px;

                    .layous-home2-C1 {
                        background: linear-gradient(to top right, #35db90, #73f3b9);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }

                    .layous-home2-C0 {
                        transition: all .2s;
                        cursor: pointer;

                        .layous-home2-L-txt {
                            margin-top: 10px;
                            font-size: 14px;
                        }
                    }

                    .layous-home2-C1:hover {
                        transform: scale(0.95);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C2:hover {
                        transform: scale(0.95);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C3:hover {
                        transform: scale(0.95);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C4:hover {
                        transform: scale(0.95);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C2 {
                        background: linear-gradient(to top right, #a063ea, #b464e5);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }

                    .layous-home2-C3 {
                        background: linear-gradient(to top right, #d3352d, #f07771);

                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }

                    .layous-home2-C4 {
                        background: linear-gradient(to top right, #1aac9b, #6aecdd);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }
                }

                .layous-home2-R {
                    //右边进入
                    flex: 1;
                    background: linear-gradient(to top right, #00a1a1, #31d1d1);
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    transition: all .2s;
                    cursor: pointer;

                    .layous-home2-L-txt {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        margin-top: 10px;
                    }
                }

                .layous-home2-R:hover {
                    transform: scale(1.1);
                    z-index: 2;
                    border-radius: 10px;
                    box-shadow: 0 0 30px 10px rgba(0, 0, 0, 0.5);
                }
            }
        }

        .layous-home-menu {
            min-width: 1000px;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 10px;
        }

        .layous-home-menu-item {
            min-height: 120px;
            flex: .25;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }

        $gradient-colors: (
            (#456ee0, #5fabef),
            (#03a6f3, #01cbef),
            (#f3ad05, #eec616),
            (#ed7255, #fb8d4c),
            (#4ec92f, #8be235),
            (#fa8b4d, #fa6f21)
        );

    @for $i from 1 through length($gradient-colors) {
        $color-pair: nth($gradient-colors, $i);
        $start-color: nth($color-pair, 1);
        $end-color: nth($color-pair, 2);

        // 计算变浅后的颜色
        $lightened-start-color: lighten($start-color, 10%);
        $lightened-end-color: lighten($end-color, 10%);

        .layous-home-menu-item:nth-child(#{$i}) {
            background: linear-gradient(to top right, $start-color, $end-color);
            /* 创建下方倒影，使用从左下角到右上角的渐变遮罩 */
            -webkit-box-reflect: below 10px linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.2));
            box-reflect: below 10px linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.2));
            transition: all .2s;

            &:hover {
                // 鼠标移入时应用变浅后的渐变背景
                transform: scale(0.9);
                z-index: 2;
                cursor: pointer;
            }
        }
    }
}
}

@media screen and (max-width: 1099px) {
    .layous-home {
        user-select: none;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;

        .layous-home-mai {
            min-width: 80%;

            .layous-home1 {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .layous-home1-L {
                    display: flex;
                    align-items: flex-end;

                    .layous-home1-L1 {
                        font-size: 50px;
                    }

                    .layous-home1-L2 {
                        line-height: 45px;
                        margin-left: 30px;
                    }
                }

                .layous-home1-R {
                    display: flex;
                    align-items: center;

                    .layous-home1-R0 {
                        text-align: right;
                        width: 150px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                        margin-right: -10px;
                        font-size: 20px !important;
                    }

                    .layous-home1-R1 {
                        font-size: 26px;
                        margin-left: 20px;
                        cursor: pointer;
                    }
                }
            }

            .layous-home2 {
                margin-top: 30px;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-gap: 10px;
                min-height: 400px;

                .layous-home2-L {
                    flex: 1;
                    background: #ee954d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    transition: all .2s;
                    cursor: pointer;

                    .layous-home2-L-img {
                        margin-top: 10px;
                    }
                }

                .layous-home2-L:hover {
                    transform: scale(1.05);
                    z-index: 2;
                    border-radius: 10px;
                    box-shadow: 0 0 30px 10px rgba(0, 0, 0, 0.5);
                }

                .layous-home2-C {
                    flex: 4;
                    display: grid;
                    grid-template-columns: 1fr;
                    grid-gap: 10px;

                    .layous-home2-C1 {
                        background: #32b67a;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }

                    .layous-home2-C0 {
                        transition: all .2s;
                        cursor: pointer;
                        padding: 10px 0;

                        .layous-home2-L-txt {
                            margin-top: 10px;
                            font-size: 14px;

                        }
                    }

                    .layous-home2-C1:hover {
                        transform: scale(1.05);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C2:hover {
                        transform: scale(1.05);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C3:hover {
                        transform: scale(1.05);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C4:hover {
                        transform: scale(1.05);
                        z-index: 2;
                        border-radius: 10px;
                    }

                    .layous-home2-C2 {
                        background: #ff8b8b;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }

                    .layous-home2-C3 {
                        background: #e54b4b;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }

                    .layous-home2-C4 {
                        background: #57968f;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                    }
                }

                .layous-home2-R {
                    flex: 1;
                    background: #349ac1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    transition: all .2s;
                    cursor: pointer;

                    .layous-home2-L-txt {
                        margin-top: 10px;
                        font-size: 14px;
                    }
                }

                .layous-home2-R:hover {
                    transform: scale(1.05);
                    z-index: 2;
                    border-radius: 10px;
                    box-shadow: 0 0 30px 10px rgba(0, 0, 0, 0.5);
                }
            }
        }

        .layous-home-menu {
            min-width: 80%;
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 10px;
        }

        .layous-home-menu-item {
            min-height: 120px;
            flex: .2;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
            flex-direction: column;
        }

        $gradient-colors: (
            (#456ee0, #5fabef),
            (#03a6f3, #01cbef),
            (#f3ad05, #eec616),
            (#ed7255, #fb8d4c),
            (#4ec92f, #8be235),
            (#fa8b4d, #fa6f21)
        );

    @for $i from 1 through length($gradient-colors) {
        $color-pair: nth($gradient-colors, $i);
        $start-color: nth($color-pair, 1);
        $end-color: nth($color-pair, 2);

        // 计算变浅后的颜色
        $lightened-start-color: lighten($start-color, 10%);
        $lightened-end-color: lighten($end-color, 10%);

        .layous-home-menu-item:nth-child(#{$i}) {
            background: linear-gradient(to top right, $start-color, $end-color);
            /* 创建下方倒影，使用从左下角到右上角的渐变遮罩 */
            -webkit-box-reflect: below 10px linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.2));
            box-reflect: below 10px linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.2));
            transition: all .2s;

            &:hover {
                // 鼠标移入时应用变浅后的渐变背景
                transform: scale(0.9);
                z-index: 2;
                cursor: pointer;
            }
        }
    }
}
}

.systemMsg {
    height: 450px;
    overflow-y: auto;
    overflow-x: hidden;

    &_mani {
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(#bec1c4, .5);
        padding: 12px 20px;
        overflow-x: hidden;

        &_items {
            flex: 1;
            display: flex;
            align-items: center;
            white-space: nowrap;
            /* 禁止换行 */
            overflow: hidden;
            /* 隐藏超出部分 */
            text-overflow: ellipsis;

            /* 使用省略号表示溢出 */
            .newData {
                width: 8px;
                height: 8px;
                flex-shrink: 0;
                border-radius: 50%;
                background: red;
            }

            .readData {
                width: 8px;
                height: 8px;
                flex-shrink: 0;
                border-radius: 50%;
                background: #67c23a;
            }

            .txts {
                white-space: nowrap;
                /* 禁止换行 */
                overflow: hidden;
                /* 隐藏超出部分 */
                text-overflow: ellipsis;
                /* 使用省略号表示溢出 */
                margin-left: 10px;
            }
        }

        &_item:nth-child(2) {
            flex-shrink: 0;
            margin-left: 60px;
        }
    }

    &_mani:hover {
        transform: scale(1.05);
        z-index: 2;
        border-radius: 10px;
        box-shadow: 0 0 30px 10px rgba(0, 0, 0, 0.5);
        cursor: pointer;
    }
}

.innersystemMsg {
    max-height: 500px;
    overflow-y: auto;
}

.msgs {
    animation: ling 1.5s forwards infinite;
    animation-delay: 0.1s;
    transform-origin: top center;
    /* 设置旋转的基点在铃铛的顶部中央 */
}

@keyframes ling {
    0% {
        transform: rotate(0);
    }

    20% {
        transform: rotate(35deg);
    }

    40% {
        transform: rotate(-20deg);
    }

    60% {
        transform: rotate(10deg);
    }

    75% {
        transform: rotate(-5deg);
    }

    80% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(0deg);
    }
}
</style>

<style lang="scss">
/* 自定义对话框样式 */
.custom-dialog {
    background-color: rgba(#eaf4ff, 1);
    /* 背景色 */
    //   border-color: #fff; /* 边框色 */
    //   color: #fff;
}

/* 如果需要修改标题栏和内容区域的样式，可以使用下面的选择器 */
.custom-dialog .el-dialog__header {
    /* 修改标题栏样式 */
    color: #fff;
}

.custom-dialog .el-dialog__title,
.el-tabs__item,
.systemMsg_mani,
.el-pagination__total,
.el-pagination__jump {
    // color: #fff;
}

.custom-dialog .el-dialog__body {
    /* 修改内容区域样式 */
}

.custom-dialog .el-pagination.is-background .el-pager li {
    margin: 0 5px;
    background-color: #979da3;
    color: #fff;
    min-width: 30px;
    border-radius: 2px;
}

.custom-dialog .el-input__inner {
    background-color: transparent;
}
</style>





<style lang="scss"></style>